import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-paycheck",
  "use": "icon-paycheck-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-paycheck\"><path d=\"M527.521137 48.558949c-246.731527 0-446.746141 200.00622-446.746141 446.727391s200.014615 446.727391 446.746141 446.727391 446.746141-200.00622 446.746141-446.727391S774.252663 48.558949 527.521137 48.558949zM527.521137 790.815123c-31.452636 0-56.950404-25.496697-56.950404-56.948013s25.497767-56.948013 56.950404-56.948013 56.950404 25.496697 56.950404 56.948013S558.973773 790.815123 527.521137 790.815123zM584.47154 549.187971c0 31.451316-25.497767 56.948013-56.950404 56.948013s-56.950404-25.496697-56.950404-56.948013L470.570733 306.138422c0-31.450293 25.497767-56.94699 56.950404-56.94699s56.950404 25.496697 56.950404 56.948013L584.47154 549.187971z\" p-id=\"2454\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/paycheck.svg
// module id = +Mec
// module chunks = 42